import { render, staticRenderFns } from "./stagesubmitanswer.vue?vue&type=template&id=0945f1d1&scoped=true"
import script from "./stagesubmitanswer.vue?vue&type=script&lang=js"
export * from "./stagesubmitanswer.vue?vue&type=script&lang=js"
import style0 from "./stagesubmitanswer.vue?vue&type=style&index=0&id=0945f1d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945f1d1",
  null
  
)

export default component.exports